import papaparse from "papaparse";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Company, Services } from "../models/Company";
import { ADMIN, COLABORADOR, GESTOR } from "../Constants/roles";

export async function readCSVFile(file: File) {
  const text = await new Response(file).text();

  const result = papaparse.parse(text, {
    skipEmptyLines: true,
  });

  return result.data.slice(2);
}

export function phoneValidToFirebaseFormat(phone: string): string {
  if (phone.replace(/\D/g, "").length === 11)
    return "+55" + phone.replace(/\D/g, "");
  return phone;
}

export function phoneMask(phone: string): string {
  phone = phone.replace("+55", "")
  return phone.replace(/\(*(\d{2})\)* *(\d{1})(\d{4}) *(\d{4})/, '($1) $2 $3-$4');
}

export function removeMaskCPF(cpf: string): string {
  return cpf.replace(/\D/g, "");
}

export function getUserRoles(user: any): string[] {
  if (!user.perfisEmpresa) {
    throw new Error("Email ou senha incorreto(s).");
  }

  const userRoles = user.perfisEmpresa.map(
    (perfil: string) => perfil.split("_")[0]
  );

  return userRoles;
}

export function getUserMainRoleFromList(userRoles: string[]): string {
  if (userRoles.includes(ADMIN)) {
    return ADMIN;
  }
  if (userRoles.includes(GESTOR)) {
    return GESTOR;
  }
  if (userRoles.includes(COLABORADOR)) {
    return COLABORADOR;
  }
  throw new Error("Usuário não possui papel definido");
}

export function getUserMainRole(user: any): string {
  const userRoles = getUserRoles(user);
  return getUserMainRoleFromList(userRoles);
}

export function diaViagemToddMMyy(diaViagem: firebase.firestore.Timestamp) {

  return format(
    new Date(diaViagem.seconds * 1000),
    "dd/MM/yy",
    { locale: ptBR }
  );

}

export function priceToBRLCurrency(valor = 0): string {

  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor);

}

export function distanceFormat(distance: number): string {

  return `${Intl.NumberFormat("pt-BR", { maximumSignificantDigits: 2 }).format(
    distance
  )} km`;

}

export function durationSecondsToHours(durationSeconds: number): string {

  return new Date(durationSeconds * 1000)
    .toISOString()
    .substr(11, 8);
}

export function getTravelPassagerName(travel: firebase.firestore.DocumentData) {
  const passenger = travel.passageiro || travel.encomenda;
  return `${passenger.nome} ${passenger.sobrenome}`;
}

export interface Address {
  street: string;
  streetNumber: string;
  neighborhood: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

interface AddressComponents {
  long_name: string;
  short_name: string;
  types: string[];
}

/**
  * Extrai os dados do endereco do retorno da API do Google
  * @return Address
  */
export function extractGoogleAddress(googleAddress: AddressComponents[]): Address {
  const administrativeLevel = [
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5'];

  const subLocalityLevel = [
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality_level_3',
    'sublocality_level_4',
    'sublocality_level_5'];

  const addressExtrated = {
    street: '',
    streetNumber: '',
    neighborhood: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
  };

  for (const el of googleAddress) {
    // console.log(el)
    const { long_name } = el;
    const arrTipos = el.types;
    if (arrTipos.some((r) => ['street_address', 'route'].includes(r)) && !addressExtrated.street) {
      addressExtrated.street = long_name;
    } else if (arrTipos.some((r) => ['street_number'].includes(r))
      && !addressExtrated.streetNumber) {
      addressExtrated.streetNumber = long_name;
    } else if (arrTipos.some((r) => subLocalityLevel.concat(['neighborhood', 'sublocality', 'political']).includes(r))
      && !addressExtrated.neighborhood) {
      addressExtrated.neighborhood = long_name;
    } else if (arrTipos.some((r) => administrativeLevel.concat(['political']).includes(r))
      && !addressExtrated.city) {
      addressExtrated.city = long_name;
    } else if (arrTipos.some((r) => ['administrative_area_level_1', 'political'].includes(r))
      && !addressExtrated.state) {
      addressExtrated.state = long_name;
    } else if (arrTipos.some((r) => ['country'].includes(r)) && !addressExtrated.country) {
      addressExtrated.country = long_name;
    } else if (arrTipos.some((r) => ['postal_code'].includes(r)) && !addressExtrated.postalCode) {
      addressExtrated.postalCode = long_name;
    }
  }
  return addressExtrated;
}

export function getServiceFieldFromCompany(company: Company): Services {
  const hasServicesField = !!company.servicos;

  if (!hasServicesField) return 'empresas';

  if (company.servicos[0] === "entregas") return "entregas";
  if (company.servicos[0] === "empresas") return "empresas";

  return 'entregas';
}

export function formatDate(
  date: Date | string,
  dateFormat = "dd/MM/yyyy 'às' HH:mm",
  options = { locale: ptBR },
): string {
  const toDate = new Date(date);
  const formattedDate = format(toDate, dateFormat, options);
  return formattedDate;
}
